var map = {
	"./1.png": 6728,
	"./2.png": 2339,
	"./3.png": 426,
	"./4.png": 853,
	"./5.png": 4940,
	"./6.png": 8871,
	"./7.png": 9374,
	"./8.png": 8761,
	"./welcome.png": 4785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9798;